import React, {useState, useEffect } from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";

import { CustomDrawer, CustomButton } from "components";
import { EVENT_TYPES } from "enum";
import Emitter from "services/emitter";
import { updateUser } from "redux/actions/home-actions";
import { TIMEZONE_LIST, COUNTRIES } from "enum";
import { notification } from "antd";
import { CloseCircleFilled } from "@ant-design/icons";
import IconLogo from "images/logo-sidebar.svg";

import ProfileEditPanel from "./ProfileEditPanel";
import ProfileViewPanel from "./ProfileViewPanel";

import { homeSelector } from "redux/selectors/homeSelector";

const ProfileDrawer  = ({userProfile:user, updateUser}) => {
  const [visible, setVisible] = useState(false);
  const [edit, setEdit] = useState(false);
  const [bulModalConfirmation, setBulModalConfirmation] = useState(false);
  const [information, setInformation] = useState({})
  const [error, setError] = useState('')

  useEffect(() => {
    Emitter.on(EVENT_TYPES.EVENT_VIEW_PROFILE, (edit) => {
      setVisible(true)
      setEdit(!!edit)
    });
  },[])

  const onDrawerClose = () => {
    setVisible(false)
    setEdit(false)
    setError('')
    setInformation({})
  };

  const onEdit = () => {setEdit(true)};

  const onSave = (userInfo) => {
    if(error){
      notification.error({
        message: error,
      });
      return 
    }
    updateUser(userInfo);
    setEdit(false)
    setInformation({})
    setError('')
  };

  const onCloseEditDrawer = (e) => {
    if(edit && Object.keys(information).length > 0){
      setBulModalConfirmation(true);
    }else{
      onDrawerClose()
    }
  }

  const timezone = (
    TIMEZONE_LIST.find((item) => item.value === user.timezone) || {}
  ).text;
  const location = (
    COUNTRIES.find((item) => item.value === user.location) || {}
  ).text;

  const esEnlace = (texto) => {
    let patronEnlaceLinkedIn = /^(https|http|ftp):\/\/[\w\-]+(\.[\w\-]+)+[^\s/$.?#].*$/i;
    return patronEnlaceLinkedIn.test(texto);
  }

  const userRequired = {
    img: !user.img ? true : false,
    firstName: !user.firstName ? true : false,
    lastName: !user.lastName ? true : false,
    titleProfessions: !user.titleProfessions ? true : false,
    company: !user.company ? true : false,
    location: !location ? true : false,
    city: !user.city ? true : false,
    // timezone: !timezone ? true : false,
    // languages: (!user.languages || Object.keys(user?.languages)?.length === 0) ? true : false,
    about: !user.about ? true : false,
    topicsOfInterest: (user.topicsOfInterest && Object.keys(user.topicsOfInterest).length === 0)  ? true : false,
    personalLinks: !user?.personalLinks?.hasOwnProperty("linkedin") ? true : false,
    personalLinksBad: !esEnlace(user?.personalLinks?.linkedin?.toLowerCase()),
    // isOpenReceivingEmail: (user.isOpenReceivingEmail === -1) ? true : false,
    recentJobLevel: !user.recentJobLevel ? true : false,
    recentWorkArea: (Array.isArray(user.recentWorkArea) && user.recentWorkArea.length === 0) ? true : false,
    sizeOfOrganization: !user.sizeOfOrganization ? true : false,
  }

  return (<>
    <CustomDrawer
      title={edit ? "Edit profile" : "Profile"}
      visible={visible}
      onClose={onCloseEditDrawer}
    >
      {edit && (
        <ProfileEditPanel
          user={user}
          onSave={onSave}
          onCancel={(e) => onCloseEditDrawer(e)}
          userRequired={userRequired}
          form={(value,err) => {
            setInformation(value);
            setError(err)
          }}
        />
      )}
      {!edit && <ProfileViewPanel user={user} onEdit={onEdit} caseMentoring={false} mentee={''} mentor={''} />}
    </CustomDrawer>
    <div 
      className={bulModalConfirmation ? "container-confirm-changes-modal" : "container-confirm-changes-modal-hidden"}
      onClick={(e) => {
        if(e.target.className === 'container-confirm-changes-modal'){
          setBulModalConfirmation(false)
          onDrawerClose()
        }
      }}
    >
      <div className="container-information">
        <div className="container-exit" onClick={() => {
          setBulModalConfirmation(false)
          onDrawerClose()
        }}>
          <CloseCircleFilled/>
        </div>
        <div className="custom-modal-title-changes">
          <h3>Save changes before closing.</h3>
          <div className="custom-modal-logo-changes">
            <img src={IconLogo} alt="custom-logo-changes" />
          </div>
        </div>
        <div className="container-buttons-changes">
          <CustomButton
            key="Cancel"
            text="Cancel"
            type="primary"
            size="xs"
            className="button-modal"
            style={{ width:'70px',padding:'0px',margin:'0px'}}
            onClick={() => {
              setBulModalConfirmation(false)
              onDrawerClose()
            }}
          />
          <CustomButton
            key="Ok"
            text="Ok"
            type="primary"
            size="xs"
            className="button-modal"
            style={{ width:'70px',padding:'0px',margin:'0px'}}
            onClick={() => {
              onSave(information)
              setBulModalConfirmation(false)
              onDrawerClose()
            }}
          />
        </div>
      </div>
    </div>
  </>);
  
}

ProfileDrawer.propTypes = {
  title: PropTypes.string,
};

ProfileDrawer.defaultProps = {
  title: "",
};

const mapStateToProps = (state, props) => ({
  userProfile: homeSelector(state).userProfile,
});

const mapDispatchToProps = {
  updateUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileDrawer);
